import { FirebaseProvider } from "@useweb/use-firebase";
import { getMessaging, getToken, onMessage } from "firebase/messaging";
import { useEffect } from "react";

import { apiurl } from "APIURL";
import axios from "axios";
import * as firebase from "firebase/app";
import "firebase/messaging";
import { useAppDispatch, useAppSelector } from "redux/hooks";
import { getProfileData } from "redux/slices/userSlice";

const firebaseConfig = {
  apiKey: "AIzaSyBPZn-QZXsVN2D74k8P7mna2SDtrPcwDvo",
  authDomain: "elearningtt-f24f0.firebaseapp.com",
  projectId: "elearningtt-f24f0",
  storageBucket: "elearningtt-f24f0.appspot.com",
  messagingSenderId: "685340629949",
  appId: "1:685340629949:web:3460ce94d06203b6be90d4",
  measurementId: "G-4Z389P1N7Q",
}; // firebaseConfig is required

const firebaseApp = firebase.initializeApp(firebaseConfig);
const messaging = getMessaging(firebaseApp);

const envIsDev = process.env.NODE_ENV === "development";

const vapidKey =
  "BJdqSLfJx1B6tSRgrBXzvRPMHXj4g68FQRzYVXAnUeCPUrmqWMkX00xvvyqDsYpWtHWvwCi8MjoSHN0gUHUXGdo"; // vapidKey is required

export default function Firebase({ children }) {
  let timer;
  const profile = useAppSelector(getProfileData);
  const dispatch = useAppDispatch();

  useEffect(() => {
    console.clear();
    const tokenSetter = async () => {
      try {
        const userId = localStorage.getItem("userId");
        const token = await getToken(messaging, { vapidKey });
        console.log(token);
        if (token) {
          const res = await axios.patch(
            `${apiurl}/notifications/registerDevice?userId=${userId}&token=${token}`
          );
          console.log(res.data);
        } else {
          Notification.requestPermission().then((permission) => {
            if (permission === "granted") {
              console.log("granted");
            } else {
              console.log("permission denied");
            }
          });
        }
      } catch (err) {
        console.log(err);
      }
    };
    tokenSetter();
    onMessage(messaging, (payload) => {
      console.log("message received:", payload);
    });
  }, []);

  return (
    <FirebaseProvider
      firebaseConfig={firebaseConfig}
      firebaseApp={firebaseApp}
      envIsDev={envIsDev}
      messaging={messaging}
      messagingOptions={{
        vapidKey,
      }}
    >
      {children}
    </FirebaseProvider>
  );
}
